import { useContext } from "react";
import BaseActions from "base/BaseActions";
import BaseModel from "base/BaseModel";
import UserModel from "./userModel";

const module = "importBatch";

const useImportBatchModel = () => {
  const { token, Organization } = useContext(UserModel.Context);

  const { getList, getOne, getConstant } = BaseActions(module, {
    token,
    Organization,
  });

  return {
    getList,
    getOne,
    getConstant,
  };
};

const ImportBatchModel = BaseModel(useImportBatchModel, "ImportBatchModel");

export { useImportBatchModel };
export default ImportBatchModel;
